import { render, staticRenderFns } from "./Issuance.vue?vue&type=template&id=f3386c40&"
import script from "./Issuance.vue?vue&type=script&lang=js&"
export * from "./Issuance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports